import { lazyWeixinJsSdk } from '@utils/lazylib';
import { canUseMeitunNativeMiniRoute } from './development';

const WEBVIEW_PATH = '/pages/webView/index';

function resolveUrl(url) {
  if (/^https?:\/\//.test(url)) return url;
  if (/^\/\//.test(url)) return `${window.location.protocol}${url}`;
  if (url.startsWith('/')) return `${window.location.origin}${url}`;
  return url;
}

function openWebView(wx, fallbackUrl) {
  if (!wx?.miniProgram?.navigateTo) return;
  wx.miniProgram.navigateTo({
    url: `${WEBVIEW_PATH}?url=${encodeURIComponent(resolveUrl(fallbackUrl))}`
  });
}

/**
 * 小程序内跳转
 * @param {string} url 小程序页面路径
 * @param {string} [fallbackUrl] H5 地址；三方宿主直接 webView，美囤宿主仅 navigateTo 失败时降级
 */
export function miniProgramNavigateTo(url, fallbackUrl) {
  return lazyWeixinJsSdk().then(wx => {
    if (!wx?.miniProgram?.navigateTo) {
      if (fallbackUrl) openWebView(wx, fallbackUrl);
      return;
    }

    if (fallbackUrl && !canUseMeitunNativeMiniRoute()) {
      openWebView(wx, fallbackUrl);
      return;
    }

    if (!fallbackUrl) {
      wx.miniProgram.navigateTo({ url });
      return;
    }

    wx.miniProgram.navigateTo({
      url,
      fail: () => openWebView(wx, fallbackUrl)
    });
  });
}
